import { Paper } from '@mui/material';
import React from 'react';
import RequestsTable from '../../../components/requeststable/requeststable.component';

const UserRequests = () => {
    return (
        <div className='admin-area-2'>
            {/* <Typography variant='h5'>User Requests</Typography> */}
            <div className='page-content'>
                <Paper>
                    <RequestsTable />
                </Paper>
            </div>
        </div>
    );
};

export default UserRequests;